import { INITIAL_STATE } from './index';
import { ActionTypes } from '../actions/action-types';

const lexon = (state = INITIAL_STATE.lexon, action = {}) => {
  switch (action.type) {
    case ActionTypes.LEXON_USER: {
      const user = action.payload;
      const provider = user.slice(0, 2);
      const isNewAccount = user.slice(2, 3) === '1' ? true : false;
      const userId = user.slice(3);
      return {
        ...state,
        user: user,
        provider: provider,
        isNewAccount: isNewAccount,
        userId: userId
      };
    }
    case ActionTypes.LEXON_ACCOUNT: {
      const account = action.payload;
      return {
        ...state,
        account
      };
    }
    case ActionTypes.LEXON_CASEFILE:
      return {
        ...state,
        idCaseFile: action.payload.casefile,
        bbdd: action.payload.bbdd,
        idCompany: action.payload.idCompany
      };

    case ActionTypes.LEXON_DATABASE:
      return {
        ...state,
        bbdd: action.payload.bbdd,
        idCompany: action.payload.idCompany
      };

    case ActionTypes.LEXON_EMAIL:
      return {
        ...state,
        idEmail: action.payload.idEmail,
        idFolder: action.payload.idFolder,
        emailShown: action.payload.emailShown
      };

    case ActionTypes.LEXON_EMAIL_SET_SHOWN:
      return { ...state, emailShown: action.payload };

    case ActionTypes.LEXON_RESET_EMAIL:
      return {
        ...state,
        idEmail: null,
        idFolder: null,
        emailShown: null
      };

    case ActionTypes.LEXON_MAILCONTACTS:
      return {
        ...state,
        mailContacts: action.payload
      };

    case ActionTypes.LEXON_DOCUMENTS_ID:
      return {
        ...state,
        documentsId: action.payload
      };

    case ActionTypes.LEXON_ACCOUNT_GUID:
      return {
        ...state,
        guid: action.payload
      };
    case ActionTypes.LEXON_ACCOUNT_SIGN:
      return {
        ...state,
        sign: action.payload
      };

    case ActionTypes.LEXON_ACCOUNT_FIRMAS:
      return {
        ...state,
        firmas: action.payload
      };


    case ActionTypes.LEXON_IDMAIL:
      return {
        ...state,
        idMail: action.payload
      };

    case ActionTypes.LEXON_ACCOUNT_TEMPLATES:
      return {
        ...state,
        templates: action.payload
      };

    case ActionTypes.LEXON_ACCOUNT_FOLDERS:
      return {
        ...state,
        folders: action.payload
      };

    case ActionTypes.LEXON_TOKEN:
      return {
        ...state,
        token: action.payload
      };

    case ActionTypes.TOKEN_WITHOUT_DOCUMENT:
      return {
        ...state,
        tokenWithoutDocument: action.payload
      };

    case ActionTypes.TOKEN:
      return {
        ...state,
        lexonToken: action.payload
      };

    case ActionTypes.LEXON_IDACTUATION:
      return {
        ...state,
        idActuation: action.payload
      };

    case ActionTypes.LEXON_IDEVENT:
      return {
        ...state,
        idEvent: action.payload
      };

    case ActionTypes.LEXON_APP_CONNECT:
      return {
        ...state,
        appConnect: action.payload
      };

    case ActionTypes.LEXON_IDCALENDAR:
      return {
        ...state,
        idCalendar: action.payload
      };

    case ActionTypes.LEXON_NEW_IDACTUATION:
      return {
        ...state,
        newIdActuation: action.payload
      };

    case ActionTypes.LEXON_NEW_IDEVENT:
      return {
        ...state,
        newIdEvent: action.payload
      };

    case ActionTypes.LEXON_TITLE:
      return {
        ...state,
        title: action.payload
      };

    case ActionTypes.LEXON_RESET_IDACTUATION:
      return {
        ...state,
        idActuation: null
      };
    case ActionTypes.LEXON_RESET_IDEVENT:
      return {
        ...state,
        idEvent: null
      };
    case ActionTypes.LEXON_FIRST_LOAD:
      return {
        ...state,
        isFirstLoad: action.payload
      };
    case ActionTypes.LEXON_ID_CLIENT_LEF:
      return {
        ...state,
        idClientLef: action.payload
      };
    case ActionTypes.LEXON_CONFIG_CALENDAR:
      return {
        ...state,
        configCalendar: action.payload
      };
    case ActionTypes.SET_ID_RESPONSABLE:
      return {
        ...state,
        idResponsable: action.payload
      };
    case ActionTypes.LEXON_CREDENTIALS_CLEAR: {
      return {...state, ...INITIAL_STATE.lexon };
    }
    case ActionTypes.APPLICATION_CUSTOMER_CONNECT_EMAIL: {
      const newState = {...state, customerConnectEmail: action.payload};
      return newState;
    }
    
    case ActionTypes.LEXON_INTERVENERS:
      return {
        ...state,
        interveners: action.payload
      };

    case ActionTypes.LEXON_SUBJECT_EMAIL:
      return {
        ...state,
        subjectEmail: action.payload
      };
    
    
    case ActionTypes.LEXON_IS_COMPOSE:
      return {
        ...state,
        isCompose: action.payload
      };

    case ActionTypes.NEXTCLOUD_ACCOUNT_AUTH:
      return {
        ...state,
        nextcloudAccountAuth: action.payload
      };
    default:
      return state;
  }
};

export default lexon;
